import type { CSSProperties } from 'react'
import css from './LabelChip.module.css'

// The label's color as a small dot. The chip and the task modal's picker button are both grey, so
// this is the only place the color appears — shared between them so the two can't drift.
const LabelDot = ({ color }: { color: string }) => (
    <span className={css.dot} style={{ '--label-color': color } as CSSProperties} />
)

export default LabelDot
